import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout';
import Home from './pages/Home';
import Insights from './pages/Insights';
import Impact from './pages/Impact';
import Collaborate from './pages/Collaborate';
import Quiz from './pages/Quiz';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="insights" element={<Insights />} />
            <Route path="impact" element={<Impact />} />
            <Route path="collaborate" element={<Collaborate />} />
            <Route path="quiz" element={<Quiz />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;